<template>
    <div>

        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-user"></i>
                Aanwezigheid
            </h2>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#presentEmployees" aria-expanded="true" aria-controls="presentEmployees">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="presentEmployees">
                <span class="text-decoration-none text-nowrap mt-3" role="button">
                    <span class="bg-lightyellow text-primary round-btn me-2">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </span>
                    <span v-on:click="setUserEmployees()" class="fw-semibold">
                        Voeg mensen toe
                    </span>
                </span>
                <div class="presence mt-4" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                    <div v-for="item in this.linkedEmployees" class="profile">
                        <figure>
                            <img v-if="item.avatar" :src="item.avatar">
                            <div v-if="item.is_present">
                            <span class="round-btn success bg-lightgreen status">
                                <i class="fa fa-check text-success icon-small"></i>
                            </span>
                            </div>
                            <div v-else>
                            <span class="round-btn danger bg-light-red status">
                                <i class="fa fa-times text-danger icon-small"></i>
                            </span>
                            </div>
                        </figure>
                        <div class="info">
                            <p class="fw-semibold text-sm mb-0">
                                {{ item.name }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {EventBus} from "../../event-bus";
    import {usePolling} from "../../composables/usePolling";
    import {useComponentVisibility} from "../../composables/useComponentVisibility";

    export default {
        name: 'present-employees',
        components: {},
        props: {
            isVisible: {
                type: Boolean,
                default: false // Voeg een standaardwaarde toe
            }
        },
        data() {
            return {
                linkedEmployees: [{
                    key: {
                        name: '',
                        city: '',
                        avatar: '',
                        is_present: '',
                    }
                }],

                componentId: 'present-employees-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });
            },
            getEmployees() {
                axios.get('api/get-employees')
                    .then(response => {
                       this.linkedEmployees = response.data.linkedEmployees;

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            setUserEmployees() {
                EventBus.$emit('linkUserEmployees');
            },
        },
        mounted() {
            const { startPolling } = usePolling(() => {
                this.getEmployees();
            }, 60000);

            startPolling();

            EventBus.$on('refetchEmployees', () => {
                console.log('refetchEmployees');
                this.getEmployees();
            });

        },
        created() {},
    }
</script>

